// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/PlanView.yaml
// Generated: 2026-06-16T13:50:13.850Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreatePlanView, UpdatePlanView, PlanView } from '@/types/finance/PlanView';

/**
 * PlanView Service
 * CRUD operations for PlanView via the ABP API.
 */
export const planViewService = new EntityService<PlanView, CreatePlanView, UpdatePlanView>(
  '/api/finance/planview',
  'PlanView',
);
